import { Route, Switch } from "react-router-dom";

import Profile from "./components/Views/Profile";
import Wrapper from "./components/Layouts/Wrapper";

function App() {
  return (
    <>
      <Wrapper>
        <Switch>
          <Route exact path="/" component={Profile} />
        </Switch>
      </Wrapper>
    </>
  );
}

export default App;
